// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__qrq9u","validationTips":"StatementDescriptor_validationTips__AraI4"};